import { render, staticRenderFns } from "./MidAutumnFestival.vue?vue&type=template&id=07acd869&scoped=true&"
import script from "./MidAutumnFestival.vue?vue&type=script&lang=js&"
export * from "./MidAutumnFestival.vue?vue&type=script&lang=js&"
import style0 from "./MidAutumnFestival.vue?vue&type=style&index=0&id=07acd869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07acd869",
  null
  
)

export default component.exports